import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  type TablePreferencesConfig,
} from 'src/common/ui/TablePreferences';

import { STRING_GROUPS_PAGE_SIZE } from 'src/features/namespace/constants';

/** Config for the string groups table; ids and order mirror `namespace/columns`. */

/** Every column the table can show, in default order. */
const COLUMN_OPTIONS = [
  // alwaysVisible: this cell holds the only link into the group's detail page.
  { id: 'stringGroupId', label: 'Name', alwaysVisible: true },
  { id: 'clientId', label: 'Client ID' },
  { id: 'teamName', label: 'Team Name' },
  { id: 'cxFamilyId', label: 'CX Family' },
  { id: 'cxIds', label: 'CX IDs' },
  { id: 'sourceLocale', label: 'Source locale' },
  { id: 'stringCount', label: 'String Count' },
  { id: 'createdAt', label: 'Created On' },
  { id: 'updatedAt', label: 'Updated On' },
] as const;

/**
 * `hideCxFamilyColumn` drops CX Family from the OPTIONS too, so the toggle is not
 * a dead control; storage is untouched, so a saved preference returns with it.
 * Memoise it — a fresh object re-creates the confirm handler.
 */
export function stringGroupsPreferencesConfig(
  hideCxFamilyColumn: boolean,
): TablePreferencesConfig {
  return {
    storageKey: 'LangHub-stringGroupsTablePreferences',
    columnOptions: hideCxFamilyColumn
      ? COLUMN_OPTIONS.filter((option) => option.id !== 'cxFamilyId')
      : COLUMN_OPTIONS,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    defaultPageSize: STRING_GROUPS_PAGE_SIZE,
  };
}
